import React from 'react';
import styles from '../ExistingSiteStoreReadyStep.scss';

interface EmbeddedVideoPlayerProps {
  src: string;
  title: string;
}

export function EmbeddedVideoPlayer({ src, title }: EmbeddedVideoPlayerProps) {
  return (
    <div className={styles.existingSiteStoreReadyVideo}>
      <iframe
        className={styles.existingSiteStoreReadyVideoEmbed}
        src={src}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </div>
  );
}
